import { CHIP_TONE_CLASSES, type StatusChip } from './reportLogic';

export function Spinner({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <span
      data-testid="chip-spinner"
      aria-hidden="true"
      className={`inline-block shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent ${className}`}
    />
  );
}

/** A report's state as a chip — Diagnosing… / Ready · confidence / Failed. */
export function ReportChip({ chip }: { chip: StatusChip }) {
  return (
    <span className={`inline-flex shrink-0 items-center gap-1.5 rounded px-2 py-1 text-[13px] font-medium ${CHIP_TONE_CLASSES[chip.tone]}`}>
      {chip.spinner && <Spinner className="h-3.5 w-3.5" />}
      {chip.label}
    </span>
  );
}

export default ReportChip;
